/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Remove_Confirm_BodyInputs */

const en_us2_clubs_remove_confirm_body = /** @type {(inputs: Clubs_Remove_Confirm_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`They leave the club and can come back only with the code.`)
};

const pt_br2_clubs_remove_confirm_body = /** @type {(inputs: Clubs_Remove_Confirm_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A pessoa sai do clube e pode voltar só com o código.`)
};

const es_419_clubs_remove_confirm_body = /** @type {(inputs: Clubs_Remove_Confirm_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sale del club y solo puede volver con el código.`)
};

const pt_pt2_clubs_remove_confirm_body = /** @type {(inputs: Clubs_Remove_Confirm_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A pessoa sai do clube e só pode voltar com o código.`)
};

const fr_fr2_clubs_remove_confirm_body = /** @type {(inputs: Clubs_Remove_Confirm_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette personne quitte le club et ne peut revenir qu'avec le code.`)
};

const de_de2_clubs_remove_confirm_body = /** @type {(inputs: Clubs_Remove_Confirm_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Person verlässt den Club und kann nur mit dem Code zurückkommen.`)
};

const it_it2_clubs_remove_confirm_body = /** @type {(inputs: Clubs_Remove_Confirm_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esce dal club e può rientrare solo con il codice.`)
};

/**
* | output |
* | --- |
* | "They leave the club and can come back only with the code." |
*
* @param {Clubs_Remove_Confirm_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_remove_confirm_body = /** @type {((inputs?: Clubs_Remove_Confirm_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Remove_Confirm_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_remove_confirm_body(inputs)
	if (locale === "es-419") return es_419_clubs_remove_confirm_body(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_remove_confirm_body(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_remove_confirm_body(inputs)
	if (locale === "de-DE") return de_de2_clubs_remove_confirm_body(inputs)
	if (locale === "it-IT") return it_it2_clubs_remove_confirm_body(inputs)
	return en_us2_clubs_remove_confirm_body(inputs)
});
export { clubs_remove_confirm_body as "clubs.remove_confirm_body" }